import { render, staticRenderFns } from "./korean_open_class.vue?vue&type=template&id=4f9eba11&scoped=true"
import script from "./korean_open_class.vue?vue&type=script&lang=js"
export * from "./korean_open_class.vue?vue&type=script&lang=js"
import style0 from "./korean_open_class.vue?vue&type=style&index=0&id=4f9eba11&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9eba11",
  null
  
)

export default component.exports